import { FC } from 'react'
import styled, { css } from 'styled-components'
import { getRgbaValue } from '../../utils/styling'

const BarEmpty = styled.div<{
  isFatter: boolean
  isThinner: boolean
  clearBg: boolean
}>`
  width: 100%;
  height: ${({ isFatter, isThinner }) =>
    isThinner ? 4 : isFatter ? 24 : 10}px;
  ${({ clearBg }) =>
    clearBg
      ? css`
      border:1px solid ${({ theme }) =>
        getRgbaValue(theme.semantics.zap.surface.primary, 0.3)}};
        margin:4px 0 2px;
        overflow:hidden;
      `
      : css`
          background: linear-gradient(
            90deg,
            ${(props) => `rgba(${props.theme.colors.brandSecondaryRgba}, 0.3)`}
              0%,
            ${(props) => `rgba(${props.theme.colors.brandSecondaryRgba}, 0.3)`}
              100%
          );
        `};
  border-radius: ${({ isFatter, isThinner }) =>
    isThinner ? 4 : isFatter ? 100 : 5}px;
  img.bolt {
    filter: invert(1);
  }
`

const BarFill = styled.div<{
  fillWidth: number
  isFatter: boolean
  isThinner: boolean
  isDiluted: boolean
}>`
  height: 100%;
  width: ${({ fillWidth }) => fillWidth}%;

  background: ${({ isDiluted }) =>
    isDiluted
      ? css`linear-gradient(90deg, #3d68ff 0%, #F4ED0C 66.66%, #F4ED0C 100%)`
      : css`linear-gradient(90deg,${(props) =>
          props.theme.colors.brandSecondary} 0%,${(props) =>
          props.theme.colors.brandPrimary} 100%)`};
  position: relative;
  border-radius: ${({ isFatter }) => (isFatter ? 100 : 5)}px;
  display: flex;
  align-items: center;
  span {
    font-size: 10px;
    letter-spacing: 0.05em;
    color: black;
    position: absolute;
    right: 8px;
    display: flex;
    img {
      margin-left: 4px;
    }
  }
`

interface Props {
  percentage: number
  displayText?: string
  clearBg?: boolean
  isFatter?: boolean
  isDiluted?: boolean
  isThinner?: boolean
}

const ProgressBar: FC<Props> = ({
  percentage,
  displayText = '0',
  isFatter = false,
  isDiluted = false,
  clearBg = false,
  isThinner = false,
}) => {
  return (
    <BarEmpty isFatter={isFatter} isThinner={isThinner} clearBg={clearBg}>
      <BarFill
        isFatter={isFatter}
        isThinner={isThinner}
        fillWidth={percentage}
        isDiluted={isDiluted}
      >
        {displayText !== '0' && percentage > 9 && (
          <span>
            {displayText}%
            {isDiluted && (
              <img
                className="bolt"
                src="/img/icons/diluted-bolt.svg"
                alt="bolt-icon"
              />
            )}
          </span>
        )}
      </BarFill>
    </BarEmpty>
  )
}

export default ProgressBar
